import { useAuthContext } from "../firebase-files/hooks/useAuthContext";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import { useCollection } from "../firebase-files/hooks/useCollection";
const Event = ({}) => {
  const { user } = useAuthContext();
  const isAdmin = user && user.role == "admin";

  const { documents: dbEventsDocuments } = useCollection("events");

  return (
    <div>
      <div className="offer_banner_parent">
        {dbEventsDocuments && dbEventsDocuments.length > 0 && (
          <OwlCarousel
            className="owl-theme"
            items={1}
            loop
            dots={true}
            nav={false}
            autoplay={true} // Enable autoplay
            autoplayTimeout={3000}
            responsive={{
              0: {
                items: 2,
              },
              600: {
                items: 4,
              },
            }}
          >
            {dbEventsDocuments &&
              dbEventsDocuments.map((eventsImage) => (
                <div key={eventsImage.id}>
                  <div style={{ margin: "10px 10px 0px 10px" }}>
                    {eventsImage &&
                      eventsImage.eventsImages &&
                      eventsImage.eventsImages.length > 0 && (
                        <div>
                          {
                            eventsImage.eventsImages.map((url, index) => {
                              // Extract the file extension
                              const extension = url
                                .split(".")
                                .pop()
                                .split("?")[0]
                                .toLowerCase();

                              if (
                                extension === "mp4" ||
                                extension === "webm" ||
                                extension === "ogg"
                              ) {
                                // If it's a video
                                return (
                                  <video
                                    key={index}
                                    style={{ maxWidth: "100%" }}
                                    controls
                                  >
                                    <source
                                      src={url}
                                      type={`video/${extension}`}
                                    />
                                    Your browser does not support the video tag.
                                  </video>
                                );
                              } else {
                                // If it's an image
                                return (
                                  <img
                                    key={index}
                                    src={url}
                                    alt={`Offer image`}
                                    className=""
                                  />
                                );
                              }
                            })[0]
                          }
                          {/* Only render the first element */}
                          <p
                            dangerouslySetInnerHTML={{
                              __html: eventsImage.Title.toString("html"),
                            }}
                          ></p>
                        </div>
                      )}
                  </div>
                </div>
              ))}
          </OwlCarousel>
        )}

        {dbEventsDocuments && dbEventsDocuments.length >= 0 && (
          <>
            <div className="small_margin_div"></div>
            <div className="d-flex justify-content-center">
              <Link to="/events">
                <button className="btn_fill home_service_mor_btn d-flex align-items-center ">
                  More
                  <span
                    class="material-symbols-outlined ba_animation"
                    style={{ marginLeft: "10px" }}
                  >
                    arrow_forward
                  </span>
                </button>
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Event;
